import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export interface NotificationSettings {
  id: string;
  discord_webhook_url: string | null;
  discord_enabled: boolean;
  telegram_bot_token: string | null;
  telegram_chat_id: string | null;
  telegram_enabled: boolean;
  email_enabled: boolean;
  email_to_address: string | null;
  email_from_address: string | null;
  email_smtp_host: string | null;
  email_smtp_port: number | null;
  email_smtp_user: string | null;
  email_smtp_password: string | null;
  notify_on_down: boolean;
  notify_on_recovery: boolean;
  notify_on_ssl_expiry: boolean;
  daily_report_enabled: boolean;
  last_report_at: string | null;
  slack_webhook_url: string | null;
  slack_enabled: boolean;
  slack_workspace_id: string | null;
  slack_workspace_name: string | null;
  slack_channel_id: string | null;
  slack_channel_name: string | null;
  slack_connected_at: string | null;
  vercel_project: string | null;
  vercel_webhook_url: string | null;
  vercel_enabled: boolean;
  vercel_trigger_condition: string;
  vercel_failures_threshold: number;
  vercel_cooldown: number;
  linear_api_key: string | null;
  linear_project_key: string | null;
  linear_enabled: boolean;
  jira_api_key: string | null;
  jira_project_key: string | null;
  jira_url: string | null;
  jira_enabled: boolean;
  teams_webhook_url: string | null;
  teams_enabled: boolean;
  datadog_api_key: string | null;
  datadog_application_key: string | null;
  datadog_enabled: boolean;
  grafana_api_key: string | null;
  grafana_url: string | null;
  grafana_enabled: boolean;
}

export function useNotificationSettings() {
  return useQuery({
    queryKey: ["notification_settings"],
    queryFn: async () => {
      return api.getSettings();
    },
    retry: 1,
    staleTime: 30_000,
  });
}

export function useUpdateNotificationSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (updates: Partial<NotificationSettings>) => {
      return api.updateSettings(updates);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notification_settings"] });
    },
  });
}
